import React from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const OutgoingMessage = ({ message }) => {
  return (
    <div className="flex justify-end">
      <div
        className="inline-flex items-center justify-center px-3 py-3 rounded-xl max-w-[80%]"
        style={{
          backgroundColor: colors.bg.fog.thin
        }}
      >
        <p
          className="whitespace-pre-line"
          style={{
            ...typography.medium.regular,
            color: colors.text.primary
          }}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default OutgoingMessage;